<script>
    import {fly} from 'svelte/transition';

    import I18n from '@js/modules/translations';

    import SearchManager from '@js/managers/searchManager';
    import {searchStore} from '@js/stores/searchStore';

    import Icon from '@js/components/themes/Icon.svelte';
    import closeIcon from '@js/components/icons/closeIcon';

    import SearchResultCard from '@js/components/search/result/SearchResultCard.svelte';

    const selectedRide = $derived($searchStore.selectedRideId ? $searchStore.ridesData.find((ride) => ride.id === $searchStore.selectedRideId) : null);
</script>

<!-- Docked under the track, in place of a popup that covered it -->
{#if selectedRide}
    <!-- Above the scale bar and the basemap logo (a 92 px column at the bottom right) -->
    <div class="absolute inset-x-2 bottom-[100px] sm:inset-x-auto sm:left-1/2 sm:-translate-x-1/2 sm:w-[28rem] z-10"
         transition:fly={{y: 24, duration: 200}}>
        <div class="relative">
            <SearchResultCard ride={selectedRide}
                              compact={true}/>

            <button type="button"
                    class="absolute -top-2 -right-2 inline-flex items-center justify-center w-8 h-8 bg-white border border-gray-200 rounded-full shadow-md hover:bg-gray-100 cursor-pointer"
                    aria-label={I18n.t('js.search.index.card.close')}
                    onclick={() => SearchManager.unselectRide()}>
                <Icon class="w-4 h-4 text-gray-700"
                      icon={closeIcon}/>
            </button>
        </div>
    </div>
{/if}
